import React from "react";
import ReactDOM from "react-dom";
import "./stylesheets/index.scss";
import App from "./pages/App";

ReactDOM.render(<App />, document.getElementById("app"));
